module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "copyright"
  }, [_c('a', {
    attrs: {
      "id": "page_iv"
    }
  }), _vm._v("© 2008 The Johns Hopkins University Press"), _c('br'), _vm._v("All rights reserved. Published 2008"), _c('br'), _vm._v("Printed in the United States of America on acid-free paper"), _c('br'), _vm._v("2  4  6  8  9  7  5  3  1")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("The Johns Hopkins University Press"), _c('br'), _vm._v("2715 North Charles Street"), _c('br'), _vm._v("Baltimore, Maryland 21218-4363"), _c('br'), _c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "http://www.press.jhu.edu",
      "target": "_blank"
    }
  }, [_vm._v("www.press.jhu.edu")])])]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_c('em', [_vm._v("Library of Congress Cataloging-in-Publication Data")])]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("Goldsmith, Jeff Charles."), _c('br'), _vm._v("     The long baby boom : an optimistic vision for a graying generation / Jeff Goldsmith."), _c('br'), _vm._v("        p. cm."), _c('br'), _vm._v("     Includes bibliographical references and index."), _c('br'), _vm._v("     ISBN-13: 978-0-8018-8851-9 (hardcover : alk. paper)"), _c('br'), _vm._v("     ISBN-10: 0-8018-8851-4 (hardcover : alk. paper)")]), _vm._v(" "), _c('p', {
    staticClass: "copy2"
  }, [_vm._v("1. Baby boom generation—United States—Psychology.  2. Baby"), _c('br'), _vm._v("boom generation—Retirement—United States.  3. Baby boom"), _c('br'), _vm._v("generation—Health and hygiene—United States.  4. Baby boom"), _c('br'), _vm._v("generation—United States—Social conditions—21st century."), _c('br'), _vm._v("5. Health attitudes—Age factors—United States.  6. Medical care—"), _c('br'), _vm._v("United States—Forecasting.  I. Title."), _c('br'), _vm._v("     HQ1063.2.U6G654 2008"), _c('br'), _vm._v("     305.2—dc22                                                          2007041649")]), _vm._v(" "), _c('p', {
    staticClass: "copy3"
  }, [_vm._v("A catalog record for this book is available from the British Library.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_c('em', [_vm._v("Special discounts are available for bulk purchases of this book. For more information, please contact Special Sales at 410-516-6936 or "), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "mailto:specialsales@press.jhu.edu"
    }
  }, [_vm._v("specialsales@press.jhu.edu")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The Johns Hopkins University Press uses environmentally friendly book materials, including recycled text paper that is composed of at least 30 percent post-consumer waste, whenever possible. All of our book papers are acid-free, and our jackets and covers are printed on paper with recycled content.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aefbb34e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/copyright.vue
// module id = 66
// module chunks = 0